import { render, staticRenderFns } from "./IndexNew.vue?vue&type=template&id=3afc1d8d&scoped=true&"
import script from "./IndexNew.vue?vue&type=script&lang=js&"
export * from "./IndexNew.vue?vue&type=script&lang=js&"
import style0 from "./IndexNew.vue?vue&type=style&index=0&lang=less&"
import style1 from "./IndexNew.vue?vue&type=style&index=1&id=3afc1d8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc1d8d",
  null
  
)

export default component.exports